/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v25.3.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
export var ServerSideStoreType;
(function (ServerSideStoreType) {
    ServerSideStoreType["Full"] = "full";
    ServerSideStoreType["Partial"] = "partial";
})(ServerSideStoreType || (ServerSideStoreType = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-community/core/dist/es6/entities/gridOptions.js
// module id = 3083
// module chunks = 0